/* eslint-disable default-param-last */
import { SET_PAYMENT_INFO, SET_SHIPPING_ADRESS } from "../actions/types";
const initState = {
    shippingAddress: { ship_state: "", shipping_address: [], shipping_address_text: [] },
    paymentInfo: { has_cards: false, preferred_payment_method: "", card_data: [] },
};
export default function generalUserInfoReducer(state = initState, action) {
    switch (action.type) {
        case SET_SHIPPING_ADRESS: {
            return {
                ...state,
                shippingAddress: action.payload,
            };
        }
        case SET_PAYMENT_INFO: {
            return {
                ...state,
                paymentInfo: action.payload,
            };
        }
        default:
            return state;
    }
}
